import * as types from "~/store/invoice/types";

const initialState = {
  invoices: [],
  loading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SEARCH_ELECTRIC_INVOICES: {
      return {
        ...state,
        loading: true
      };
    }
    case types.SEARCH_ELECTRIC_INVOICES_SUCCESS: {
      return {
        ...state,
        invoices: action.payload,
        loading: false
      };
    }
    case types.SEARCH_ELECTRIC_INVOICES_FAILURE: {
      return {
        ...state,
        loading: false
      };
    }
    case types.SEND_EMAIL_INVOICE: {
      return {
        ...state,
        loading: true
      };
    }
    case types.SEND_EMAIL_INVOICE_SUCCESS:
    case types.SEND_EMAIL_INVOICE_FAILURE: {
      return {
        ...state,
        loading: false
      };
    }
    default: {
      return state;
    }
  }
};
